import { useState, useEffect} from "react";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import ActivePositions from "./CrPositions";
import { TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import { makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { getPositions , getAllocatedto , getCompany } from "./services";
import crownIcon from "../../assets/images/crown_icon_fill.svg";
import { getAPI } from "../../api/api";
import { REACT_APP_COMMON } from "../../utils/common";

function CrPositions() {
  
  
  let loginId: any = localStorage.getItem('loginId') 
  const menu = makeSideBarActive(CONSTANTS.crSideMenu, 0)
  const BreadcrumsValues = ["CRPositions"];
  const [filterNumber, setFilterNumber] = useState<number>()
  const [filterValues, setFilterValues] = useState<any>(null)
  const [companyList, setCompanyList] = useState<any>()
  const [selected, setSelected] = useState<number>(0)
  const [positions, setPositions] = useState<any>()
  const [appliedPositions, setappliedPositions] = useState<any>()
  const [activeTotal, setActiveTotal] = useState<number>()
  const [totalActivePositions, setTotalActivePositions] = useState<number>()
  const [appliedPosTotal, settappliedPosTotal] = useState<number>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [positionName, setPositionName] = useState<any>()
  const [sort, setSort] = useState<any>([]);
  const [skillList, setSkillList] = useState<any>()

  const findTab = (value: number) => {
    let val = "";
    switch (value) {
      case 0:
        return (val = "activePosition");
        break;
      case 1:
        return (val = "appliedPosition");
        break;
      default:
        return (val = "activePosition");
    }
  }

  useEffect(() => {

    getAllPositions(loginId, 1, 25, 'activePosition', ' ')
    getAllPositions(loginId, 1, 25, 'appliedPosition', ' ')
    getAllocation()
    getCompanyList()
   
    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

  }, [])

  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === "success") {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        )
      }
    })
  }

  const getCompanyList = () => {
    getCompany().then((response: any) => {
      if (response && response.status === "1") {
        setCompanyList(response.data.map((item:any) => item.companyName));
      }
    });
  };


  const getAllPositions = (
    loginId: string,
    pageNumber: number,
    pageSize: number,
    tab: string,
    searchValue?: string,
    filter?: any,
    sort?:any
  ) => {
    let data = {}
    if(filter){
      data = {
        filters : filter,
        // sort :{
        //   sortBy: "priority",
        //   sortOrder: "ASC"
        // }
      }
    }else{
      data = {
        filters : {}
      }
    }
    
  getPositions(loginId , pageNumber, pageSize, tab , searchValue, data).then((resp) => { 
      if (resp && resp.status === 1) {  
        switch(tab){
          case 'activePosition':
            setPositions(resp.data)     
            setActiveTotal(resp.totalPositionsCountWithFilter)
            setTotalActivePositions(resp.totalCount[0].totalCount)
            break;
          case "appliedPosition":
            setappliedPositions(resp.data);
            settappliedPosTotal(resp.totalCount[0].totalCount)
            break;
        }
      }
    })
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const searchChange = (e: string) => {
    
    getAllPositions(loginId, 1, 25, 'activePosition', e, filterValues)
    getAllPositions(loginId, 1, 25, 'appliedPosition', e, filterValues)
  }

  const getPosition = (pageSize: any, pageNumber: number) => {
    
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
    getAllPositions(findTab(selected), page, pageSize, "", filterValues,sort);
    
  }

  const applyFilter = (data: any) => {
    
    getAllPositions(loginId, 1, 25, 'activePosition', ' ', data, sort)
    getAllPositions(loginId, 1, 25, 'appliedPosition', ' ', data,sort)
    delete data.skillsCombination
    setFilterValues(data);
   
  }

  const applySort = (sort: any) => {

    getAllPositions(loginId, 1, 25, 'activePosition', ' ', filterValues, sort)
    getAllPositions(loginId, 1, 25, 'appliedPosition', ' ', filterValues,sort)
  }

  const closeTag = (data: any) => { 
    applyFilter(data)
  }

  const ActiveTab = <>Active Positions <i>{totalActivePositions}</i></>;
  const AppliedTab = <>Applied Positions <i>{appliedPosTotal}</i></>;
 
  const pageChange = () => {
    getAllPositions(findTab(selected), 1, 25, "", filterValues,sort);
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyCrPositionFilter={applyFilter}
          companyList={companyList}
          filterNumber={filterNumber}
          allocatedTo={allocatedTo}
          searchChange={searchChange}
          closeTag={closeTag}
          filterValues={filterValues}
          positionName={positionName}
          type='CRPositions'
          skillsList={skillList}
        />
        <section className={Styles.positionWrapper}>
          <div className={Styles.activePositions}>
            <img src={crownIcon}/>Active positions<span>{totalActivePositions}</span></div>          
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title={ActiveTab} >
                <ActivePositions setSort={setSort} applySort={applySort} positions={positions} total={activeTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
              <Tab title={AppliedTab}>
                <ActivePositions setSort={setSort} applySort={applySort} positions={appliedPositions} total={appliedPosTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  );
}

export default CrPositions;
